<template>
  <div class="source">
    <TabsHead active-tab="source"> </TabsHead>
    <Card>
      <Tabs v-model="activeTab">
        <TabPane :name="tabs[0]" :label="$t('streams.stream')">
          <Streams class="tab-body"></Streams>
        </TabPane>
        <TabPane :name="tabs[1]" :label="$t('tables.scanTable')">
          <Tables class="tab-body"></Tables>
        </TabPane>
        <TabPane :name="tabs[2]" :label="$t('tables.lookupTable')">
          <LookupTable class="tab-body" />
        </TabPane>
      </Tabs>
    </Card>
  </div>
</template>

<script>
import TabsHead from '@/components/TabsHead'
import Streams from './Streams.vue'
import Tables from './Tables.vue'
import LookupTable from './LookupTable.vue'

export default {
  name: 'Source',
  data() {
    return {
      activeTab: 0,
      tabs: ['stream', 'scanTable', 'lookupTable'],
    }
  },
  components: {
    TabsHead,
    Streams,
    Tables,
    LookupTable,
  },
  created() {
    const { tabName } = this.$route.query
    this.activeTab = tabName && this.tabs.includes(tabName) ? tabName : this.tabs[0]
  },
}
</script>

<style lang="scss">
.source {
  .ivu-card-body {
    padding: 0;
  }
  .tab-body {
    padding: 20px;
  }
}
</style>
